export default __webpack_public_path__ + "static/kado-1-f5f67f11bf6c086d801e71263b17ba6d.jpg";